export default __webpack_public_path__ + "static/media/hht2_ep01_timeline_06.85847805.png";